import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { EditorialLink } from '@/components/Landing/LandingValueStory';
import { MONO } from '@/components/Landing/landingTokens';
import { ENDPOINT_GROUPS } from '@/constants/apiContent';
import { ApiBody, ApiSection, ApiTitle } from './ApiEditorial';

function ApiEndpoints() {
  const { c, band, isCompact, isXS } = useLanding();
  return (
    <ApiSection label="API endpoints" background={band.bg}>
      <View style={{ flexDirection: isCompact ? 'column' : 'row', justifyContent: 'space-between', gap: 24, marginBottom: 32 }}>
        <ApiTitle>The API reference.</ApiTitle>
        <View style={{ maxWidth: 460 }}>
          <ApiBody>Chat, generate media, work with files, and manage your account. Use one key across these endpoints.</ApiBody>
          <EditorialLink href="/docs/api-endpoints" style={{ marginTop: 8 }}>Request and response documentation</EditorialLink>
        </View>
      </View>
      {ENDPOINT_GROUPS.map(group => (
        <View key={group.group} style={{ marginTop: 24 }}>
          <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 18, lineHeight: 25, marginBottom: 14 }}>{group.group}</Text>
          {group.endpoints.map(endpoint => (
            <View key={endpoint.method + endpoint.path} style={{ flexDirection: isCompact ? 'column' : 'row', gap: isCompact ? 6 : 28, paddingVertical: 13, borderTopWidth: 1, borderTopColor: c.rule }}>
              <View style={{ flex: isCompact ? undefined : 1, flexDirection: 'row', alignItems: 'baseline', gap: 14, minWidth: 0 }}>
                <Text weight="medium" style={{ color: c.accent, fontFamily: MONO, fontSize: 11, lineHeight: 20, width: 34 }}>{endpoint.method}</Text>
                <Text style={{ color: c.ink, fontFamily: MONO, fontSize: isXS ? 11 : 13, lineHeight: 21, flex: 1 }}>{endpoint.path}</Text>
              </View>
              <Text style={{ flex: isCompact ? undefined : 1, color: c.inkSoft, fontSize: 14, lineHeight: 22, paddingLeft: isCompact ? 48 : 0 }}>{endpoint.label}</Text>
            </View>
          ))}
        </View>
      ))}
    </ApiSection>
  );
}
export default React.memo(ApiEndpoints);
